import * as React from "react";
import { Button, Text } from "@uikit";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modules
import StarRating from "../../starRating";
import { Image } from "@kalabo/golfsavers-common";

interface IProps {
  title: string;
  image?: Image;
  rating: number;
  price: string;
  salePercentage?: number;
}

const CourseItem = ({
  title,
  image,
  rating,
  price,
  salePercentage,
}: IProps) => {
  return (
    <div>
      <div className="select-none flex flex-col items-center">
        <div className="group overflow-hidden w-full  aspect-w-3 aspect-h-2 rounded mb-[10px]">
          <img
            src={image?.url}
            alt={image?.alt}
            className={`object-center object-cover transform transition-all duration-500  hover:scale-125`}
          />
        </div>

        <div className="flex flex-1 w-full items-center justify-between">
          <div className="w-full">
            <Text size="h5" color="black" className="line-clamp-1">
              {title}
            </Text>
            <div className="flex gap-[2px] mb-4 mt-1">
              <StarRating rating={rating} size="small" />
            </div>
            <div className="flex">
              <Text size="tiny" className="mt-2 mr-1" italic color="black60">
                from
              </Text>{" "}
              <div className="flex items-end">
                <Text size="boldlarge" color="blue" className="leading-[1]">
                  {price}
                </Text>
                <Text size="boldtiny" color="blue" className="ml-[2px]">
                  pp
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseItem;
